export default "__VITE_ASSET__bde18faf__"